export default __webpack_public_path__ + "static/media/p3.0168ffc9.jpg";